// extracted by mini-css-extract-plugin
export default {"card":"PaymentMethodCard_card__4rs1-","copy":"PaymentMethodCard_copy__-KvRr","error":"PaymentMethodCard_error__8gYbX","button":"PaymentMethodCard_button__BuQz0"};